import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow-x: hidden;
  overflow-y: overlay;
  flex: 1;

  & > div {
    max-width: 448px;
  }

  button {
    max-width: 384px;
  }
`;

export const ErrorWrapper = styled.div`
  border: 1px solid var(--colorUIRed);
  border-radius: 4px;
  padding: 16px;
  background-color: #ffc9c9;
  margin: 16px;
  height: 500px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;

  a {
    color: var(--colorUIBlue);
  }
`;
